<template>
  <div class="z-[1] relative bg-yellow-500 mb-64">
    <div class="px-8 pb-24 pt-20 md:px-12 md:pb-32 md:pt-24">
      <div class="mx-auto max-w-5xl">
        <div class="flex flex-col items-start gap-7 text-left md:items-center md:text-center">
          <div class="text-lg font-medium lg:text-xl">{{ t('pages.features.comprehensive.hero.kicker') }}</div>
          <h2 class="text-5xl font-medium md:text-6xl lg:text-7xl xl:text-8xl">{{ t('pages.features.comprehensive.hero.title') }}</h2>
          <div class="max-w-3xl text-lg md:text-2xl lg:leading-10 xl:text-3xl">
            <i18n-t keypath="pages.features.comprehensive.hero.body">
              <template #emphasis>
                <em>{{ t('pages.features.comprehensive.hero.emphasis') }}</em>
              </template>
            </i18n-t>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col overflow-hidden border-t border-black lg:flex-row mb-32">
      <div class="bg-dark-teal-100 flex items-center justify-center border-b border-black bg-orange p-8 py-16 sm:p-12 md:p-16 lg:w-1/2 lg:border-b-0 lg:border-r xl:p-16">
        <div class="relative">
          <SmartImage :alt="t('pages.features.comprehensive.hero.imageAlt')" class="h-auto w-full" data-parallax="true" src="/images/features/shipping.png" image-style="transform: translateY(0px);" />
          <SmartImage :alt="t('pages.features.comprehensive.hero.stickerAlt')" class="absolute -right-10 -top-10 w-32 transform-gpu parallax-coins md:w-64 md:-right-32 md:-top-20" data-parallax="true" src="/images/features/easy.svg" image-style="transform: translateY(0px);" />
          <SmartImage :alt="t('pages.features.comprehensive.hero.tagAlt')" class="absolute -bottom-20 left-0 w-40 transform-gpu parallax-coins md:w-48" data-parallax="true" src="/images/features/box.svg" image-style="transform: translateY(0px);" />
        </div>
      </div>

      <div class="flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
        <div class="max-w-2xl space-y-12 md:space-y-16">
          <div class="space-y-4">
            <h3 class="text-dark-teal-100 text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              {{ t('pages.features.comprehensive.blocks.shipApp.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.comprehensive.blocks.shipApp.body') }}
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-light-pink-300 text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              {{ t('pages.features.comprehensive.blocks.sellAnything.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.comprehensive.blocks.sellAnything.body') }}
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-yellow-400 text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              {{ t('pages.features.comprehensive.blocks.networkDiscount.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              <i18n-t keypath="pages.features.comprehensive.blocks.networkDiscount.body">
                <template #emphasis>
                  <em>{{ t('pages.features.comprehensive.blocks.networkDiscount.emphasis') }}</em>
                </template>
              </i18n-t>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '#imports'
import SmartImage from '~/components/SmartImage.vue'

const { t } = useI18n()
</script>
